import apiClient from "./axios"

export const getAccountVehiclePurchases = async (params = {}) => {
  const response = await apiClient.get('/account-vehicle-purchases', { params })
  return response.data
}

export const getAccountVehiclePurchase = async (id) => {
  const response = await apiClient.get(`/account-vehicle-purchases/${id}`)
  return response.data
}

export const createAccountVehiclePurchase = async (payload) => {
  const response = await apiClient.post('/account-vehicle-purchases', payload)
  return response.data
}

export const updateAccountVehiclePurchase = async (id, payload) => {
  const response = await apiClient.patch(`/account-vehicle-purchases/${id}`, payload)
  return response.data
}

export const deleteAccountVehiclePurchase = async (id) => {
  const response = await apiClient.delete(`/account-vehicle-purchases/${id}`)
  return response.data
}
